<form autocomplete="off" [formGroup]="form" (ngSubmit)="save()">
    <h4>Detalle de evento prospectivo</h4>
    <div *ngIf="movesLog && accessMP" class="p-3 mb-3 rounded" style="background-color: #f8f9fa; border: 1px solid #dee2e6;">
        <div class="form-group row">
            <label class="col-md-2 col-form-label">Creado</label>
            <div class="col-md-4">
                <p class="form-control-plaintext text-left">
                    {{ movesLog['creationLog']?.nameUser
                    ? (movesLog['creationLog']?.nameUser + ' - ' + (movesLog['creationLog']?.createdAt |
                    date:'dd/MM/yyyy HH:mm'))
                    : 'No se cuenta con registros del creador.' }}
                </p>
            </div>
            <label class="col-md-2 col-form-label">Editado</label>
            <div class="col-md-4">
                <p *ngIf="movesLog['editLog']" class="form-control-plaintext text-left">
                    {{ movesLog['editLog']?.nameUser }} - {{ movesLog['editLog']?.updatedAt | date:'dd/MM/yyyy HH:mm' }}
                </p>
                <p *ngIf="!movesLog['editLog']" class="form-control-plaintext text-left text-muted">
                    No se cuenta con registros de modificaciones.
                </p>
            </div>
        </div>
    </div>
    <hr>
    <div class="form-group row">

        <div class="textOnInput col-12 col-md-12">
            <label class="form-label">Título</label>
            <input class="form-control" type="text" placeholder="Título" formControlName="title" autocomplete="off"
                [class.is-invalid]="campoNoValido('title')">
            <small class="text-danger" *ngIf="campoNoValido('title')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-12 col-md-12">
            <label class="form-label">Autor</label>
            <input class="form-control" type="text" placeholder="Autor" formControlName="autor"
                [class.is-invalid]="campoNoValido('autor')">
            <small class="text-danger" *ngIf="campoNoValido('autor')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-6 col-md-6">
            <label class="form-label">Fecha de publicación</label>
            <input class="form-control" type="date" formControlName="date" [class.is-invalid]="campoNoValido('date')">
            <small class="text-danger" *ngIf="campoNoValido('date')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-6 col-md-6">
            <label class="form-label">Fecha de expiración</label>
            <input class="form-control" type="date" formControlName="dateexpiry" autocomplete="off">
        </div>

        <div class="textOnInput col-12 col-md-12">
            <label class="form-label">Sumilla</label>
            <textarea class="form-control" placeholder="Sumilla" formControlName="content"
                [class.is-invalid]="campoNoValido('content')" rows="3"></textarea>
            <small class="text-danger" *ngIf="campoNoValido('content')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-12 col-md-12">
            <label class="form-label">Tags</label>
            <input class="form-control" type="text" placeholder="tag1. tag2, tag3" formControlName="tags">
        </div>

        <div class="textOnInput col-12 col-md-12">
            <label class="form-label">URL de la fuente</label>
            <input class="form-control" type="text" placeholder="URL" formControlName="source"
                [class.is-invalid]="campoNoValido('source')">
            <small class="text-danger" *ngIf="campoNoValido('source')">Este campo es requerido</small>
        </div>

        <div class="textOnInput col-12">
            <label class="form-label">Imagen</label>
            <div class="label-container ">
                <div class="row">
                    <div class="col-md-9">
                        <div class="input-group">
                            <div class="input-group-append">
                                <button class="btn btn-outline-primary custom-rounded-button" type="button"
                                    (click)="fileInput.click()">
                                    Cargar imagen
                                </button>
                            </div>
                            <input type="text" disabled class="form-control" placeholder="Imagen" formControlName="img">
                        </div>
                        <input #fileInput class="form-file" type="file" id="input-file" (change)="onFileChange($event)"
                            accept="image/png, .jpg, .webp" style="display: none;">
                    </div>
                    <div class="col-md-3">
                        <ng-container *ngIf="form.get('img').value != null">
                            <ng-container *ngIf="isUploadDir">
                                <img class="img-fluid" src="{{URL}}{{form.get('img').value}}" alt=""
                                    style="height: 120px; width:100px">
                            </ng-container>
                            <ng-container *ngIf="!isUploadDir">
                                <img src="{{form.get('img').value}}" alt="No se ha cargado una imagen"
                                    style="height: 50px;">
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>

        <div class="textOnInput col-12">
            <label class="form-label" for="inputText">Documentos relacionados (PDF)</label>
            <div class="label-container">
                <div class="row align-items-center">
                    <div class="col-md-12" style="margin-top: 20px;">
                        <div class="input-group">
                            <div class="input-group-append">
                                <button class="btn btn-outline-primary custom-rounded-button" type="button"
                                    (click)="fileInputPdf.click()">
                                    Cargar PDF
                                </button>
                            </div>
                            <input type="text" disabled class="form-control" placeholder="PDF" formControlName="doc">
                        </div>
                        <input #fileInputPdf class="form-file" type="file" id="input-file-pdf"
                            (change)="onPdfChange($event)" accept=".pdf" multiple style="display: none;">
                    </div>
                    <div class="col-md-12" style="margin-top: 20px;">
                        <ul class="pdf-list">
                            <li *ngFor="let pdfName of tempfilenamePDF; let i = index">
                                <div class="pdf-item">
                                    <span>{{i+1}}.</span> <input type="text" class="pdf-name" [value]="pdfName"
                                        (blur)="updatetempfilenamePDF(i, $event.target.value)">
                                    <button type="button" class="pdf-delete-button" (click)="removePdf(i)">x</button>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>


        <div class="textOnInput col-12">
            <label class="form-label" for="inputText">URL youtube EMBED</label>
            <textarea class="form-control" formControlName="urls" autocomplete="off"
                [class.is-invalid]="campoNoValido('urls')" rows="6" [value]="getFormattedUrls()"
                (input)="onUrlInputChange()"></textarea>
            <small class="text-danger" *ngIf="campoNoValido('urls')">Este campo es requerido</small>
            <div class="small-message">
                {{ errorMessage }} <!-- Muestra el mensaje informativo aquí -->
            </div>
        </div>

        <div class="col-12 text-end">
            <button class="btn btn-outline-secondary" type="button" data-bs-toggle="collapse"
                data-bs-target="#collapseWidthExample" aria-expanded="false" aria-controls="collapseWidthExample">
                <i class="fa fa-question-circle" aria-hidden="true"></i>
            </button>
            <div>
                <div class="collapse width text-start" id="collapseWidthExample">
                    <div class="card bg-light">
                        <ol>
                            <ul>1. Abre YouTube en tu navegador web.</ul>
                            <ul>2. Busca el video de YouTube que deseas incorporar en tu sitio web.</ul>
                            <ul>3. Haz clic en el video para abrirlo.</ul>
                            <ul>4. Debajo del video, verás una serie de botones, incluyendo "Compartir". Haz clic en el
                                botón
                                "Compartir".</ul>
                            <ul>5. Haz clic en el botón "Insertar" en la parte superior de la ventana emergente.</ul>
                            <ul>6. Visualizarás un código de la forma:
                                <code>
                        &lt;iframe width="560" height="315"
                        src="<b>https://www.youtube.com/embed/NxSFTiPSY1s?si=_d0Id2Qrp7JCLXNj</b>"
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay;
                        clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen&gt;&lt;/iframe&gt;
                    </code>
                            </ul>
                            <ul>7. Selecciona solo la parte de
                                <b>https://www.youtube.com/embed/NxSFTiPSY1s?si=_d0Id2Qrp7JCLXNj</b>
                                Este es nuestro código embed de YouTube que deberás copiar en tu caja de texto del
                                observatorio.
                            </ul>
                            <ul>8. En caso de tener más de una URL EMBED de YouTube, repite el proceso, copiando el
                                código
                                después de hacer Enter por cada registro.</ul>
                            <ul>9. Por último, con todos nuestros registros listos, procedemos a guardar utilizando el
                                botón
                                "Guardar".</ul>

                        </ol>
                    </div>
                </div>
            </div>
        </div>


        <div class="textOnInput col-12">
            <label class="form-label" for="inputText">Estado</label>
            <div class="label-container align-switch">
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" id="switch1" formControlName="status">
                </div>
            </div>
        </div>

    </div>

    <div class="row">
        <div class="col-12">
            <div class="d-flex justify-content-start">
                <div class="me-2">
                    <button type="button" class="btn btn-outline-secondary btn-block" (click)="cancel()">
                        Cancelar
                    </button>
                </div>
                <div>
                    <button type="submit" class="btn btn-outline-primary">Guardar</button>
                </div>
            </div>
        </div>
    </div>

</form>
